import { ShieldCheck, Clock, Users, Award, Check } from "lucide-react";
import { MEDIA, TRUST_BADGES, STATS } from "../../lib/content";

const ICONS = { ShieldCheck, Clock, Users, Award };

const reasons = [
  "Fully licensed, bonded & insured for your protection",
  "Certified arborists with a safety-first approach",
  "Transparent, no-surprise pricing on every quote",
  "Complete debris cleanup — we leave it spotless",
  "24/7 emergency & storm-damage response",
];

export const WhyChooseUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-gold/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="absolute -inset-3 border border-gold/30 rounded-xl -z-0" />
            <img
              src={MEDIA.about}
              alt="Arborist climbing and pruning a tree"
              className="relative z-10 rounded-xl w-full h-[480px] object-cover"
              data-testid="why-us-image"
            />
            <div className="absolute z-20 -bottom-6 -right-4 md:right-6 bg-gold text-black px-7 py-5 rounded-lg shadow-2xl">
              <p className="font-serif text-3xl font-bold leading-none">Trees</p>
              <p className="text-xs uppercase tracking-widest mt-1">Property • Pride</p>
            </div>
          </div>

          <div>
            <p className="font-cursive text-gold text-2xl md:text-3xl">Why Choose Us</p>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mt-1">
              The Crew That Treats Your Property Like Our Own
            </h2>
            <p className="mt-6 text-gray-400 leading-relaxed">
              For years, EVERETT - Sam's Treescape has delivered premium tree care with the
              precision of true craftsmen. Every job is handled with meticulous care, industry-leading
              equipment, and genuine respect for you and your land.
            </p>

            <ul className="mt-8 space-y-4">
              {reasons.map((r) => (
                <li key={r} className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center text-gold flex-shrink-0">
                    <Check size={14} />
                  </span>
                  <span className="text-gray-200">{r}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-20">
          {TRUST_BADGES.map((b) => {
            const Icon = ICONS[b.icon];
            return (
              <div
                key={b.label}
                data-testid={`trust-badge-${b.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="flex flex-col items-center text-center gap-3 bg-[#111111] border border-gold/20 rounded-xl p-6 hover:border-gold/50 transition-colors"
              >
                <Icon className="text-gold" size={32} />
                <span className="text-sm uppercase tracking-widest text-gray-200">{b.label}</span>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
          {STATS.map((s) => (
            <div key={s.label} className="text-center py-6">
              <p className="font-serif text-4xl md:text-5xl font-bold gold-text-gradient">{s.value}</p>
              <p className="text-xs uppercase tracking-widest text-gray-400 mt-2">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
